import { RunsRollup } from '@/components/rollups/Rollups';
import { api } from '@/lib/api';
import { useCompanyCtx } from './CompanyLayout';

/** Every run across this company's engagements, newest first. */
export function CompanyActivityTab() {
  const { company } = useCompanyCtx();
  return (
    <RunsRollup fetchKey={`co-${company.id}`} fetch={() => api.listCompanyRuns(company.id)} companySlug={company.slug} />
  );
}
